// extracted by mini-css-extract-plugin
module.exports = {"total":"Total_total__3xWIs","totalText":"Total_totalText__3rcHx","students":"Total_students__3jDx1","teachers":"Total_teachers__3mly3","courses":"Total_courses__2LkTp"};